module.exports = __webpack_public_path__ + "img/wappin-logo.722e0e2b.png";